import {Component, OnDestroy, OnInit, EventEmitter, Output, Input} from '@angular/core';
import {FormControl, FormGroup, FormArray, Validators} from '@angular/forms';
import {RouteService} from '../../../shared/services/route.service';
import {Stop} from '../../../shared/models/stop.model';
import {DataStorageService} from '../../../shared/services/data-storage.service';
import {Route} from '../../../shared/models/route.model';
import {BookingService} from '../../../shared/services/booking.service';
import {PassengerCreate} from 'src/app/shared/models/passenger.model';
import {DiscountService} from '../../../shared/services/discount.service';
import {ToolsService} from '../../../shared/services/tools.service';
import {AuthenticationService} from '../../../authentication/authentication.service';
import {UserLogin} from '../../../shared/models/user.model';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DatePipe} from '@angular/common';
import {Observable} from 'rxjs/Rx';
import {UserService} from '../../../shared/services/user.service';
import {RouteGroup} from "../../../shared/models/routeGroup.model";

@Component({
    selector: 'form-add-routing',
    styleUrls: ['form-add-routing.scss'],
    templateUrl: 'form-add-routing.html'
})
export class FormAddRoutingComponent implements OnInit, OnDestroy {

    routingForm: FormGroup;
    @Output() userIdChanged = new EventEmitter<string>();

    isRoundTrip: boolean;

    isValidTicket = true;
    is_disable_day_dep: boolean;
    is_disable_day_re:boolean;
    @Output() amountChanged = new EventEmitter<string>();
    // Emits a plain booking-summary object to the parent so the summary
    // can be rendered as a sidebar in form-add-reservation.
    @Output() summaryChanged = new EventEmitter<any>();

    // ---- Airport filtering (JFK / EWR) ----
    private readonly JFK_STOP_ID = 8;   // JFK airport-level stop id
    private readonly EWR_STOP_ID = 20;  // EWR airport-level stop id

    private _airportType = 'JFK';

    @Input()
    set airportType(value: string) {
        // Normalize: only 'JFK' or 'EWR' are valid; null/undefined -> default JFK.
        const next = value === 'EWR' ? 'EWR' : 'JFK';
        const changed = next !== this._airportType;
        this._airportType = next;
        console.log('[airportType] received:', value, '-> using:', this._airportType); // debug; remove later
        // Run the full airport switch only after the form exists and only on real change.
        if (this.routingForm && changed) {
            this.onAirportChanged();
        }
    }
    get airportType(): string {
        return this._airportType;
    }

    invoiceDepAmount: number;
    invoiceReAmount: number;
    adult_price_Dep: number;
    adult_price_Re: number;
    child_price_Dep: number;
    child_price_Re: number;
    originalAdultPriceDep: number;
    originalChildPriceDep: number;
    originalInfantPriceDep: number;
    originalAdultPriceRe: number;
    originalChildPriceRe: number;
    originalInfantPriceRe: number;
    discountAdultPriceDep: number;
    discountChildPriceDep: number;
    discountInfantPriceDep: number;

    stops: Stop[] = [];
    passengers: PassengerCreate[] = [];
    agencyOptions: any = [];

    availableDepStopFromOptions: any = [];
    availableReStopFromOptions: any = [];
    availableDepStopToOptions: any = [];
    availableReStopToOptions: any = [];
    fromSelectVisible = true;


    min_date: any = new Date();
    min_date_re: any = new Date();

    discountTypeOptions: any = [
        {'value': '', 'label': 'No Discount'}
        // , {'value': 'valid_ticket', 'label': 'Valid Ticket'}
        , {'value': 'promo_code', 'label': 'Promo Code'}];
    discountOptions: any;
    discountConfig: any = {
        labelField: 'label',
        valueField: 'value',
        searchField: ['value']
    };

    passengerNumOptions: any = [
        {'value': 0, 'label': 'ADT'},
        {'value': 1, 'label': 'ADT 1'},
        {'value': 2, 'label': '2'},
        {'value': 3, 'label': '3'},
        {'value': 4, 'label': '4'},
        {'value': 5, 'label': '5'},
        {'value': 6, 'label': '6'}
    ];
    passengerChildNumOptions: any = [
        {'value': 0, 'label': 'CNN'},
        {'value': 1, 'label': '1'},
        {'value': 2, 'label': '2'},
        {'value': 3, 'label': '3'},
        {'value': 4, 'label': '4'},
        {'value': 5, 'label': '5'},
        {'value': 6, 'label': '6'}
    ];
    passengerInfantNumOptions: any = [
        {'value': 0, 'label': 'INF'},
        {'value': 1, 'label': '1'},
        {'value': 2, 'label': '2'},
        {'value': 3, 'label': '3'},
        {'value': 4, 'label': '4'},
        {'value': 5, 'label': '5'},
        {'value': 6, 'label': '6'}
    ];
    passengerNumConfig: any = {
        labelField: 'label',
        valueField: 'value',
        searchField: ['value']
    };

    selectConfig: any = {
        labelField: 'value',
        valueField: 'value',
        searchField: ['value']
    };

    stopSelectConfig: any = {
        labelField: 'label',
        valueField: 'value',
        searchField: ['value']
    };

    modelDep;
    modelRe;

    date: { year: number, month: number };

    availableDepRoutes: Route[] = [];
    availableReRoutes: Route[] = [];

    amount = 0;

    blockedDates: any[] = [];
    is_blocked_dep: boolean;
    is_blocked_re: boolean;

    is_discount: boolean;

    is_submit_touched: boolean;

    is_on_check: boolean;
    ipAddress = '';
    adult_num = 1;
    child_num = 0;
    infant_num = 0;

    user: UserLogin;

    /* Valid Ticket (free shuttle) permission.
       Level 3 without a PCC may not use it; every other level is unchanged (stays true). */
    canUseValidTicket = true;

    private unsubscribe$: Subject<void> = new Subject<void>();

    constructor(private routeService: RouteService,
                private dataStorageService: DataStorageService,
                private bookingService: BookingService,
                private authenticationService: AuthenticationService,
                private toolsService: ToolsService,
                private discountService: DiscountService,
                private datePipe: DatePipe,
                private userService: UserService) {
        this.isRoundTrip = false;
        this.is_discount = false;
        this.is_on_check = false;
        this.is_submit_touched = false;
    }

    ngOnInit() {
        setTimeout(
            () => {
                if (this.user.level < 3) {
                    this.min_date.setDate(this.min_date.getDate());
                    this.min_date_re.setDate(this.min_date_re.getDate());
                } else {
                    this.min_date.setDate(this.min_date.getDate() + 2);
                    this.min_date_re.setDate(this.min_date_re.getDate() + 2);
                }
                this.min_date = {year: this.min_date.getFullYear(), month: this.min_date.getMonth() + 1, day: this.min_date.getDate()};
                this.min_date_re = {
                    year: this.min_date_re.getFullYear(), month: this.min_date_re.getMonth() + 1, day: this.min_date_re.getDate()
                };
            }, 500
        );

        this.authenticationService.user
            .pipe(takeUntil(this.unsubscribe$)).subscribe(user => {
            if (user) {
                this.user = user;
                // Level 3 only: read PCC from the server; no PCC -> restrict Valid Ticket.
                if (+user.level === 3) {
                    this.dataStorageService.fetchUser(+user.id)
                        .pipe(takeUntil(this.unsubscribe$)).subscribe(u => {
                        const pcc = u && u.pcc ? String(u.pcc).trim() : '';
                        this.canUseValidTicket = pcc !== '';
                        if (!this.canUseValidTicket) { this.restrictValidTicket(); }
                    });
                }
            }
        });
        this.initAgencyOptions();
        this.initForm();
        // init discount
        this.setDiscountType('valid_ticket');

        // init rt
        this.setTripType('rt');

        this.stops = this.routeService.getStop();
        this.initDepStopOptions();


        this.blockedDates = this.routeService.getBlockedDates();
        this.routeService.blockedDatesChanged
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            blockedDates => {
                this.blockedDates = blockedDates;
            }
        );

        this.initDiscountOptions();
        this.discountService.discounts_sub
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            value => {
                this.initDiscountOptions();
            }
        );

        this.routeService.stopsChanged
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            (stops: Stop[]) => {
                this.stops = stops;
            }
        );

        this.routeService.routesChanged
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            () => {
                this.initDepStopOptions();
            }
        );
        this.routingForm.get('user_id').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    console.log(value);
                    this.userIdChanged.emit(value);
                }
            );

        this.routingForm.get('tripType').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    this.setTripType(value);
                    this.emitSummary(); // trip type affects summary (One Way / Round Trip)
                }
            );

        this.routingForm.get('isValidTicket').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    this.isValidTicket = value === 'yes';
                    this.bookingService.setIsValidTicket(this.isValidTicket);

                    const controls_a = this.getAdultControls();
                    const controls_c = this.getChildControls();
                    const controls_i = this.getInfantControls();

                    if (this.isValidTicket) {
                        this.setDiscountType('valid_ticket');
                        // disable ticket validator
                        for (let i = 0; i < this.adult_num; i++) {
                            controls_a[i].get('ticket_no').enable();
                        }
                        for (let i = 0; i < this.child_num; i++) {
                            controls_c[i].get('ticket_no').enable();
                        }
                        /*                        for (let i = 0; i < this.infant_num; i++) {
                                                    controls_i[i].get('ticket_no').disable();
                                                }*/
                    } else {
                        this.setDiscountType('');
                        this.routingForm.get('discountType').setValue('');
                        if (this.isRoundTrip) {
                            this.checkIsSameDate();
                        }
                        // enable ticket validator
                        for (let i = 0; i < this.adult_num; i++) {
                            controls_a[i].get('ticket_no').disable();
                        }
                        for (let i = 0; i < this.child_num; i++) {
                            controls_c[i].get('ticket_no').disable();
                        }
                        /*                        for (let i = 0; i < this.infant_num; i++) {
                                                    controls_i[i].get('ticket_no').disable();
                                                }*/
                    }
                    this.emitSummary(); // valid-ticket toggle changes the displayed total
                }
            );

        this.routingForm.get('adultNum').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    if (+value === 0 && +this.routingForm.get('childNum').value === 0) {
                        alert('Please select at least one passenger');
                    }
                    this.bookingService.adult_num_changed.next(value);
                }
            );
        this.routingForm.get('childNum').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    if (+value === 0 && +this.routingForm.get('adultNum').value === 0) {
                        alert('Please select at least one passenger');
                    }
                    this.bookingService.child_num_changed.next(value);
                }
            );

        this.routingForm.get('infantNum').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    const numericValue = parseInt(value, 10); // convert string to number
                    if (numericValue === 0 && +this.routingForm.get('adultNum').value === 0) {
                        alert('Please select at least one passenger');
                    }
                    console.log('valueChanges', typeof numericValue);
                    this.bookingService.infant_num_changed.next(numericValue);
                }
            );

        this.bookingService.adult_num_changed
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            (adult_num) => {
                const diff = Math.abs(this.adult_num - adult_num);
                // console.log(diff);
                if (this.adult_num > adult_num) {
                    // minus
                    this.adult_num = adult_num;
                    for (let i = 0; i < diff; i++) {
                        this.setAdultControls('minus');
                    }
                } else {
                    // plus
                    this.adult_num = adult_num;
                    for (let i = 0; i < diff; i++) {
                        this.setAdultControls('plus');
                    }
                }
                this.emitSummary(); // passenger count affects total
            }
        );

        this.bookingService.child_num_changed
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            (child_num) => {
                const diff = Math.abs(this.child_num - child_num);
                // console.log(diff);
                if (this.child_num > child_num) {
                    // minus
                    this.child_num = child_num;
                    for (let i = 0; i < diff; i++) {
                        this.setChildControls('minus');
                    }
                } else {
                    // plus
                    this.child_num = child_num;
                    for (let i = 0; i < diff; i++) {
                        this.setChildControls('plus');
                    }
                }
                this.emitSummary(); // passenger count affects total
            }
        );

        this.bookingService.infant_num_changed
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            (infant_num) => {
                const diff = Math.abs(this.infant_num - infant_num);
                console.log(typeof diff);
                if (this.infant_num > infant_num) {
                    // minus
                    this.infant_num = infant_num;
                    for (let i = 0; i < diff; i++) {
                        this.setInfantControls('minus');
                    }
                } else {
                    // plus
                    this.infant_num = infant_num;
                    for (let i = 0; i < diff; i++) {
                        this.setInfantControls('plus');
                    }
                }
                this.emitSummary(); // passenger count affects total
            }
        );

        // Get Available Drop Location
        this.routingForm.get('ticketDep').get('stopPick').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    const stops = this.routeService.setAvailableDepStopTo(value);
                    this.initDepStopToOptions(stops);
                    // Return Route set pick location option
                    this.setReStopPickOption(value);
                }
            );
        this.routingForm.get('ticketRe').get('stopPick').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    const stops = this.routeService.setAvailableReStopTo(value);
                    this.initReStopToOptions(stops);
                }
            );

        this.routingForm.get('ticketDep').get('date').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                value => {
                    // Set min return date
                    this.min_date_re = value;
                    if (this.isRoundTrip && !this.isValidTicket) {
                        this.checkIsSameDate();
                    }
                });

        this.routingForm.get('ticketRe').get('date').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                value => {
                    if (this.isRoundTrip && !this.isValidTicket) {
                        this.checkIsSameDate();
                    }
                }
            );

        // Get Available Routes
        this.routingForm.get('ticketDep').get('stopPick').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    this.setAvailableDepRoutes();
                }
            );
        this.routingForm.get('ticketDep').get('stopDrop').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    this.setAvailableDepRoutes();
                }
            );
        this.routingForm.get('ticketDep').get('date').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    this.setAvailableDepRoutes();
                }
            );
        this.routingForm.get('ticketRe').get('stopPick').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    this.setAvailableReRoutes();
                }
            );
        this.routingForm.get('ticketRe').get('stopDrop').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    this.setAvailableReRoutes();
                }
            );
        this.routingForm.get('ticketRe').get('date').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    this.setAvailableReRoutes();
                }
            );

        // Check Is Blocked
        this.routingForm.get('ticketDep').get('routeDep').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    if (value) {
                        this.checkIsNightDepSchedule(value.route_group_id);
                        this.checkIsBlocked(value.route_group_id, this.routingForm.get('ticketDep').get('date').value, 'dep');
                        this.bookingService.setDepTicket(
                            value.id,
                            this.routingForm.get('ticketDep').get('date').value,
                            this.is_blocked_dep
                        );
                    }
                    this.emitSummary(); // departure route / date changed
                }
            );
        this.routingForm.get('ticketRe').get('routeRe').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                (value) => {
                    if (value) {
                        this.checkIsNightReSchedule(value.route_group_id);
                        this.checkIsBlocked(value.route_group_id, this.routingForm.get('ticketRe').get('date').value, 're');
                        this.bookingService.setReTicket(
                            value.id,
                            this.routingForm.get('ticketRe').get('date').value,
                            this.is_blocked_re
                        );
                    }
                    this.emitSummary(); // return route / date changed
                }
            );

        // Set Discount Type
        this.routingForm.get('discountType').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                value => {
                    this.setDiscountType(value);
                    this.emitSummary(); // discount type changes the displayed total
                }
            );

        // Set Discount Price
        this.routingForm.get('promoCode').valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(
                () => {
                    this.is_discount = true;
                    this.setDepRouteDiscountPrice();
                    if (this.isRoundTrip) {
                        this.setReRouteDiscountPrice();
                    }
                    this.emitSummary(); // promo discount changes the displayed total
                }
            );

        // check if valid
        this.bookingService.setTicketsEmitter
            .pipe(takeUntil(this.unsubscribe$)).subscribe(
            () => {
                this.is_submit_touched = true;
                // console.log('here');
                this.checkIsValid();
            }
        );

        this.userService.setIPAddress().pipe(takeUntil(this.unsubscribe$)).subscribe((res: any) => {
                this.ipAddress = res.ip;
            }
        );
    }


    /* Init Form Elements */

    /* Level 3 without PCC: force "no valid ticket" and lock the radio.
       Setting 'no' runs the existing isValidTicket.valueChanges handler (discount reset,
       ticket_no validators off), so the paid-booking path is exactly the one that already exists. */
    private restrictValidTicket() {
        if (!this.routingForm) { return; }
        const ctrl = this.routingForm.get('isValidTicket');
        if (ctrl.value !== 'no') { ctrl.setValue('no'); }
        ctrl.disable({emitEvent: false});
    }

    initForm() {

        const reservationPassengersAdult = new FormArray([
            new FormGroup({
                'first_name': new FormControl(),
                'last_name': new FormControl(),
                'ticket_no': new FormControl(null
                    , [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]
                    , this.asyncInvalidProjectName.bind(this))
            })
        ]);
        const reservationPassengersChild = new FormArray([]);
        const reservationPassengersInfant = new FormArray([]);

        this.routingForm = new FormGroup({
            'isValidTicket': new FormControl('yes'),
            'tripType': new FormControl('rt'),
            'ticketDep': new FormGroup({
                'stopPick': new FormControl(null, Validators.required),
                'stopDrop': new FormControl(null, Validators.required),
                'date': new FormControl(null, Validators.required),
                'routeDep': new FormControl(null, Validators.required)
            }),
            'ticketRe': new FormGroup({
                'stopPick': new FormControl(null, Validators.required),
                'stopDrop': new FormControl(null, Validators.required),
                'date': new FormControl(null, Validators.required),
                'routeRe': new FormControl(null, Validators.required)
            }),
            'discountType': new FormControl('valid_ticket'),
            'promoCode': new FormControl(null, Validators.required),
            'user_id': new FormControl(this.user.id),
            // 'pnr': new FormControl(null, [Validators.required
            //     , Validators.minLength(6), Validators.maxLength(6)]),
            'adultNum': new FormControl(1),
            'childNum': new FormControl(0),
            'infantNum': new FormControl(0),
            'passengersAdult': reservationPassengersAdult,
            'passengersChild': reservationPassengersChild,
            'passengersInfant': reservationPassengersInfant,
            'pnr': new FormControl(null
                , [Validators.required, Validators.minLength(6)
                    , Validators.maxLength(6)]),
        });

    }

    initDiscountOptions() {
        const discounts = this.discountService.getDiscount();
        if (discounts) {
            this.bookingService.setDiscount(discounts);
            const today_raw = new Date();
            const today = this.datePipe.transform(today_raw, 'yyyy-MM-dd');
            this.discountOptions = [{'label': 'Discount Code', 'value': ''}];
            for (const discount of discounts) {
                if (discount.start_issue <= today && discount.end_issue >= today) {
                    this.discountOptions.push({'label': discount.title, 'value': discount.code});
                }
            }
        }
    }

    /*    initDepStopOptions() {
            // Build From-stop options, scoped to the selected airport's route network.
            const airportStops = this.getAirportStopIdSet();
            const availableDepStops = this.routeService.getAvailableDepStopFrom();
            availableDepStops.sort((a, b) => (a.id < b.id ? -1 : 1));
            this.availableDepStopFromOptions = []; // clear before rebuild (also fixes duplicate append)
            for (const stop of availableDepStops) {
                // If airport data is not ready (empty set), fall back to showing all stops.
                if (airportStops.size === 0 || airportStops.has(Number(stop.id))) {
                    this.availableDepStopFromOptions.push({'label': stop.title, 'value': stop.id, 'code': stop.title});
                }
            }
        }*/
    initDepStopOptions() {
        // Build From-stop options, scoped to the selected airport's route network.
        const airportStops = this.getAirportStopIdSet();
        const availableDepStops = this.routeService.getAvailableDepStopFrom();
        availableDepStops.sort((a, b) => (+a.id < +b.id ? -1 : 1)); // numeric sort (ids arrive as strings)
        this.availableDepStopFromOptions = []; // clear before rebuild (also fixes duplicate append)
        for (const stop of availableDepStops) {
            // If airport data is not ready (empty set), fall back to showing all stops.
            if (airportStops.size === 0 || airportStops.has(Number(stop.id))) {
                this.availableDepStopFromOptions.push({'label': stop.title, 'value': stop.id, 'code': stop.title});
            }
        }
        this.rebuildFromSelect();
    }

    /* Re-create the From ng-selectize so it drops its internal option cache.
       Without this, stops shared with the previous airport (e.g. Elkins Park, Exit 7-7A)
       silently disappear from the dropdown after switching JFK -> EWR. */
    private rebuildFromSelect() {
        this.fromSelectVisible = false;
        setTimeout(() => { this.fromSelectVisible = true; }, 0);
    }

    setReStopPickOption(depPickStop) {
        const availableReStops = this.routeService.getAvailableReStopFrom(depPickStop);
        for (const stop of availableReStops) {
            this.availableReStopFromOptions.push({'label': stop.title, 'value': stop.id, 'code': stop.title});
        }
    }

    initDepStopToOptions(stops) {
        this.availableDepStopToOptions = [];
        for (const stop of stops) {
            this.availableDepStopToOptions.push({'value': stop.id, 'label': stop.title});
        }
    }

    initReStopToOptions(stops) {
        this.availableReStopToOptions = [];
        for (const stop of stops) {
            this.availableReStopToOptions.push({'value': stop.id, 'label': stop.title});
        }
    }


    initAgencyOptions() {
        const users = this.userService.getUser();
        users.sort((a, b) => (a.user_name.toUpperCase() < b.user_name.toUpperCase() ? -1 : 1));
        for (const user of users) {
            this.agencyOptions.push({'label': user.user_name, 'value': user.id, 'code': user.user_name});
        }
    }
    setAvailableDepRoutes() {
        this.availableDepRoutes = this.routeService.setSelectedDepRoute(
            this.routingForm.get('ticketDep').get('stopPick').value,
            this.routingForm.get('ticketDep').get('stopDrop').value,
            this.routingForm.get('ticketDep').get('date').value
        );
        // Route-table level airport filter (JFK=8 / EWR=20). Works even if stop scoping is skipped.
        this.availableDepRoutes = this.filterRoutesByAirport(this.availableDepRoutes);
        for (const r of this.availableDepRoutes) {
            if (r['base_adult_price'] == null) { r['base_adult_price'] = r.adult_price; }
            if (r['base_child_price'] == null) { r['base_child_price'] = r.child_price; }
        }
        if (this.is_discount) {
            if (this.routingForm.get('discountType').value === 'valid_ticket') {
                this.setDepRouteDiscountValidTicketPrice();
            } else {
                this.setDepRouteDiscountPrice();
            }
        }else {
            this.setDepRoutePrice();
        }
        if (!this.toolsService.isEmpty(this.availableDepRoutes[0])) {
            this.routingForm.get('ticketDep').get('routeDep').patchValue(this.availableDepRoutes[0]);
        }
    }

    setAvailableReRoutes() {
        this.availableReRoutes = this.routeService.setSelectedReRoute(
            this.routingForm.get('ticketRe').get('stopPick').value,
            this.routingForm.get('ticketRe').get('stopDrop').value,
            this.routingForm.get('ticketRe').get('date').value
        );
        // Route-table level airport filter (JFK=8 / EWR=20).
        this.availableReRoutes = this.filterRoutesByAirport(this.availableReRoutes);
        for (const r of this.availableReRoutes) {
            if (r['base_adult_price'] == null) { r['base_adult_price'] = r.adult_price; }
            if (r['base_child_price'] == null) { r['base_child_price'] = r.child_price; }
        }
        if (this.is_discount) {
            if (this.routingForm.get('discountType').value === 'valid_ticket') {
                if (this.isRoundTrip) {
                    this.setReRouteDiscountValidTicketPrice();
                }
            } else {
                if (this.isRoundTrip) {
                    this.setReRouteDiscountPrice();
                }
            }
        }else{
            this.setReRoutePrice();
        }
        if (!this.toolsService.isEmpty(this.availableReRoutes[0])) {
            this.routingForm.get('ticketRe').get('routeRe').patchValue(this.availableReRoutes[0]);
        }
    }

    /* Return the airport-level stop ID for the currently selected airport. */
    /* Airport-level stop id for the current selection. */
    private getAirportStopId(): number {
        return this._airportType === 'EWR' ? this.EWR_STOP_ID : this.JFK_STOP_ID;
    }

    /* All stop ids that appear on routes touching the selected airport.
       Connecting stop ids are DERIVED here from route data (never hardcoded).
       NOTE: getRoute() must return ALL routes. If your RouteService exposes them
       under another name, change ONLY this line. If unavailable, stop-option
       scoping is skipped gracefully and the route TABLE is still airport-filtered. */
    private getAirportStopIdSet(): Set<number> {
        const airportStopId = this.getAirportStopId();
        const ids = new Set<number>();
        const allRoutes: Route[] = this.routeService.getRoute() || [];
        const today = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
        for (const r of (allRoutes || [])) {
            // Skip routes whose service period has already ended (keeps expired stops out of the list).
            if (r.end_date && r.end_date < today) { continue; }
            const pick = Number(r.pick_stop_id);
            const drop = Number(r.drop_stop_id);
            if (pick === airportStopId || drop === airportStopId) {
                ids.add(pick);
                ids.add(drop);
            }
        }
        return ids;
    }

    /* Keep only routes whose pick OR drop stop is the selected airport stop. */
    private filterRoutesByAirport(routes: Route[]): Route[] {
        if (!routes || routes.length === 0) { return routes || []; }
        const airportStopId = this.getAirportStopId();
        return routes.filter(r =>
            Number(r.pick_stop_id) === airportStopId || Number(r.drop_stop_id) === airportStopId
        );
    }

    /* Full airport switch: clear stale data -> rebuild options -> reset invalid
       selections -> re-fetch routes if a complete search is still valid. */
    private onAirportChanged() {
        if (!this.routingForm) { return; }

        // 1) Clear route tables + any selected route (remove stale data).
        this.availableDepRoutes = [];
        this.availableReRoutes = [];
        this.routingForm.get('ticketDep').get('routeDep').setValue(null, {emitEvent: false});
        this.routingForm.get('ticketRe').get('routeRe').setValue(null, {emitEvent: false});

        // 2) Rebuild airport-scoped From-stop options.
        this.availableReStopFromOptions = [];
        this.initDepStopOptions();

        // 3) Reset stop selections that don't belong to the new airport.
        this.resetSelectionsForAirport();

        // 4) Re-fetch + re-filter only if a full search remains.
        this.refreshAvailableRoutes();
    }

    /* Drop stopPick/stopDrop when the current pick is not in the new airport set. */
    private resetSelectionsForAirport() {
        const airportStops = this.getAirportStopIdSet();
        if (airportStops.size === 0) { return; } // data not ready -> keep current values
        const dep = this.routingForm.get('ticketDep');
        if (dep.get('stopPick').value != null && !airportStops.has(Number(dep.get('stopPick').value))) {
            dep.get('stopPick').setValue(null, {emitEvent: false});
            dep.get('stopDrop').setValue(null, {emitEvent: false});
        }
        const re = this.routingForm.get('ticketRe');
        if (re.get('stopPick').value != null && !airportStops.has(Number(re.get('stopPick').value))) {
            re.get('stopPick').setValue(null, {emitEvent: false});
            re.get('stopDrop').setValue(null, {emitEvent: false});
        }
    }

    /* Re-run route fetch + filter, only when a full search is present
       (so routeService is never called with null args, no empty-array race). */
    private refreshAvailableRoutes() {
        if (!this.routingForm) { return; }
        const dep = this.routingForm.get('ticketDep');
        if (dep.get('stopPick').value && dep.get('stopDrop').value && dep.get('date').value) {
            this.setAvailableDepRoutes();
        }
        const re = this.routingForm.get('ticketRe');
        if (this.isRoundTrip && re.get('stopPick').value && re.get('stopDrop').value && re.get('date').value) {
            this.setAvailableReRoutes();
        }
    }
    checkIsSameDate() {
        const dep_date = this.routingForm.get('ticketDep').get('date').value;
        const re_date = this.routingForm.get('ticketRe').get('date').value;
        if (dep_date && re_date) {
            const dep_date_str = dep_date.year + dep_date.month + dep_date.day;
            const re_date_str = re_date.year + re_date.month + re_date.day;
            if (dep_date_str === re_date_str) {
                this.routingForm.get('promoCode').setValue('SAMEDATERT');
                this.setDiscountType('promo_code');
                this.routingForm.get('discountType').setValue('promo_code');
            }
        }
    }


    /* passengers */
    getAdultControls() {
        return (<FormArray>this.routingForm.get('passengersAdult')).controls;
    }

    getChildControls() {
        return (<FormArray>this.routingForm.get('passengersChild')).controls;
    }

    getInfantControls() {
        return (<FormArray>this.routingForm.get('passengersInfant')).controls;
    }

    setAdultControls(direction) {
        if (direction === 'minus') {
            (<FormArray>this.routingForm.get('passengersAdult')).removeAt(this.adult_num);
        } else {
            (<FormArray>this.routingForm.get('passengersAdult')).push(
                new FormGroup({
                    'first_name': new FormControl(),
                    'last_name': new FormControl(),
                    'ticket_no': new FormControl(null
                        , [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]
                        , this.asyncInvalidProjectName.bind(this))
                })
            );
        }
    }

    setChildControls(direction) {
        if (direction === 'minus') {
            (<FormArray>this.routingForm.get('passengersChild')).removeAt(this.child_num);
        } else {
            (<FormArray>this.routingForm.get('passengersChild')).push(
                new FormGroup({
                    'first_name': new FormControl(),
                    'last_name': new FormControl(),
                    'ticket_no': new FormControl(null
                        , [Validators.required, Validators.minLength(10), Validators.maxLength(10), Validators.pattern('^[0-9]*$')]
                        , this.asyncInvalidProjectName.bind(this))
                })
            );
        }
    }

    setInfantControls(direction) {
        if (direction === 'minus') {
            (<FormArray>this.routingForm.get('passengersInfant')).removeAt(this.infant_num);
        } else {
            (<FormArray>this.routingForm.get('passengersInfant')).push(
                new FormGroup({
                    'first_name': new FormControl(),
                    'last_name': new FormControl()
                })
            );
        }
    }


    /* Tools */

    checkIsBlocked(route_group_id: number, date: any, kind: string) {
        date = date.year + '-' + date.month + '-' + date.day;
        const new_date = this.datePipe.transform(date, 'yyyy-MM-dd');
        const route_group = this.routeService.getRouteGroupById(route_group_id);
        const dispatch_group_id = route_group.dispatch_group_id;
        if (kind === 'dep') {
            this.is_blocked_dep =
                this.blockedDates.some(el => el.date === new_date && el.dispatch_group_id === dispatch_group_id);
        } else if (kind === 're') {
            this.is_blocked_re =
                this.blockedDates.some(el => el.date === new_date && el.dispatch_group_id === dispatch_group_id);
        }
    }

    setTripType(value) {
        const ticketReControl = this.routingForm.get('ticketRe');
        if (value === 'rt') {
            this.isRoundTrip = true;
            ticketReControl.get('stopPick').enable();
            ticketReControl.get('stopDrop').enable();
            ticketReControl.get('date').enable();
            ticketReControl.get('routeRe').enable();
        } else {
            ticketReControl.get('stopPick').disable();
            ticketReControl.get('stopDrop').disable();
            ticketReControl.get('date').disable();
            ticketReControl.get('routeRe').disable();
            this.isRoundTrip = false;
        }
    }

    setDiscountType(value) {
        const pnrControl = this.routingForm.get('pnr');
        const promoCodeControl = this.routingForm.get('promoCode');
        switch (value) {
            case '':
                pnrControl.disable();
                promoCodeControl.disable();
                this.is_discount = false;
                this.bookingService.setIsValidTicket(this.isValidTicket);
                this.setDepRoutePrice();
                if (this.isRoundTrip) {
                    this.setReRoutePrice();
                }
                break;
            case 'valid_ticket':
                pnrControl.enable();
                promoCodeControl.disable();
                this.is_discount = true;
                this.bookingService.setIsValidTicket(true);
                this.setDepRouteDiscountValidTicketPrice();
                if (this.isRoundTrip) {
                    this.setReRouteDiscountValidTicketPrice();
                }
                break;
            case 'promo_code':
                pnrControl.disable();
                promoCodeControl.enable();
                if (!promoCodeControl.value) {
                    this.is_discount = false;
                }
                break;
        }
    }
    setDepRouteDiscountPrice() {
        const disc = this.bookingService.getDiscountAmountByCode(this.routingForm.get('promoCode').value);
        for (const availableRoute of this.availableDepRoutes) {
            // Adult & Child each discounted from their own DB base price.
            this.adult_price_Dep = availableRoute['base_adult_price'];
            this.child_price_Dep = availableRoute['base_child_price'];
            availableRoute.discount_price = availableRoute['base_adult_price'] - disc;
            availableRoute['child_discount_price'] = availableRoute['base_child_price'] - disc;
        }
    }

    setReRouteDiscountPrice() {
        const disc = this.bookingService.getDiscountAmountByCode(this.routingForm.get('promoCode').value);
        for (const availableRoute of this.availableReRoutes) {
            this.adult_price_Re = availableRoute['base_adult_price'];
            this.child_price_Re = availableRoute['base_child_price'];
            availableRoute.discount_price = availableRoute['base_adult_price'] - disc;
            availableRoute['child_discount_price'] = availableRoute['base_child_price'] - disc;
        }
    }
    setDepRoutePrice() {
        for (const availableRoute of this.availableDepRoutes) {
            // Regular fare comes from the route's own DB price (no hardcoded amount).
            availableRoute.adult_price = availableRoute['base_adult_price'];
            availableRoute.child_price = availableRoute['base_child_price'];
        }
    }

    setReRoutePrice() {
        for (const availableRoute of this.availableReRoutes) {
            availableRoute.adult_price = availableRoute['base_adult_price'];
            availableRoute.child_price = availableRoute['base_child_price'];
        }
    }

    setDepRouteDiscountValidTicketPrice() {
        for (const availableRoute of this.availableDepRoutes) {
            // Strikethrough = original DB price; valid Asiana ticket -> Adult & Child free.
            this.adult_price_Dep = availableRoute['base_adult_price'];
            this.child_price_Dep = availableRoute['base_child_price'];
            availableRoute.discount_price = 0;                  // Adult free
            availableRoute['child_discount_price'] = 0;         // Child free
            this.invoiceDepAmount = availableRoute.discount_price;
            availableRoute.adult_price = availableRoute.discount_price;   // bill free
            availableRoute.child_price = availableRoute.discount_price;
        }
    }

    setReRouteDiscountValidTicketPrice() {
        for (const availableRoute of this.availableReRoutes) {
            this.adult_price_Re = availableRoute['base_adult_price'];
            this.child_price_Re = availableRoute['base_child_price'];
            availableRoute.discount_price = 0;
            availableRoute['child_discount_price'] = 0;
            this.invoiceReAmount = availableRoute.discount_price;
            availableRoute.adult_price = availableRoute.discount_price;
            availableRoute.child_price = availableRoute.discount_price;
        }
    }

    checkIsNightDepSchedule(route_id: number) {
        const routeGroupId: number = parseInt(String(route_id), 10);
        if (routeGroupId === 3 || routeGroupId === 4  && this.is_discount) {
            this.originalAdultPriceDep = this.invoiceDepAmount;
            this.originalChildPriceDep = this.invoiceDepAmount;
        } else {
            this.originalAdultPriceDep = 0;
            this.originalChildPriceDep = 0;
        }
    }

    checkIsNightReSchedule(route_id: number) {
        const routeGroupId: number = parseInt(String(route_id), 10);
        if (routeGroupId === 3 || routeGroupId === 4  && this.is_discount) {
            this.originalAdultPriceRe = this.invoiceReAmount;
            this.originalChildPriceRe = this.invoiceReAmount;

        } else {
            this.originalAdultPriceRe = 0;
            this.originalChildPriceRe = 0;
        }
    }

    checkIsTicketHead(e, target_input) {
        if (e.target.value) {
            if (e.target.value.indexOf('988') === 0) {
                alert('Please enter 10 digits ticket number only. ');
                const target = target_input.split('_');
                if (target[0] === 'adult') {
                    const controls = this.getAdultControls();
                    controls[target[1]].get('ticket_no').setValue('');
                }
                if (target[0] === 'child') {
                    const controls = this.getChildControls();
                    controls[target[1]].get('ticket_no').setValue('');
                }
            }
        }
    }

    asyncInvalidProjectName(control: FormControl): Promise<any> | Observable<any> {
        const promise = new Promise((resolve, reject) => {
            this.dataStorageService.fetchFlightTicketNoCount(control.value)
                .pipe(takeUntil(this.unsubscribe$)).subscribe(
                value => {
                    if (value) {
                        alert('This ticket number is already in use. ');
                        control.patchValue(null);
                        resolve({'ticketNoTaken': true});
                    } else {
                        resolve(null);
                    }
                }
            );
        });
        return promise;
    }

    /* Check Before Submit  */

    checkIsValid() {
        if (this.isValidTicket && this.toolsService.isEmpty(this.routingForm.get('pnr').value)) {
            this.bookingService.submitFirst.next(false);
        } else {
            // console.log(this.routingForm);
            if (this.routingForm.valid) {

                let is_valid = true;

                const value = this.routingForm.value;
                if (this.routingForm.get('discountType').value === 'promo_code') {
                    if (!this.checkIsValidDiscountCode(value.promoCode, value.ticketDep.date)) {
                        is_valid = false;
                        this.routingForm.get('promoCode').setErrors({'invalid': true});
                    }
                    if (value.tripType === 'rt') {
                        if (!this.checkIsValidDiscountCode(value.promoCode, value.ticketRe.date)) {
                            is_valid = false;
                            this.routingForm.get('promoCode').setErrors({'invalid': true});
                        }
                    }
                }
                if (is_valid) {
                    this.onSubmit();
                }
            } else {
                this.bookingService.submitFirst.next(false);
            }
        }
    }

    checkIsValidDiscountCode(promoCode: string, date: any) {
        return this.bookingService.checkIsValidDiscountCode(promoCode, date);
    }

    /* Booking summary helpers (display only) */
    private getLegTotal(routeVal: any): number {
        if (!routeVal) { return 0; }
        const adultUnit  = this.is_discount ? routeVal.discount_price          : routeVal.adult_price;
        const childUnit  = this.is_discount ? routeVal['child_discount_price'] : routeVal.child_price;
        const infantUnit = routeVal.infant_price;
        return (adultUnit  || 0) * this.adult_num
            + (childUnit  || 0) * this.child_num
            + (infantUnit || 0) * this.infant_num;
    }

    get bookingTotal(): number {
        const dep = this.getLegTotal(this.routingForm.get('ticketDep').get('routeDep').value);
        const re  = this.isRoundTrip ? this.getLegTotal(this.routingForm.get('ticketRe').get('routeRe').value) : 0;
        return dep + re;
    }

    private formatStruct(s: any): string {
        if (!s || s.year == null) { return ''; }
        const mm = s.month < 10 ? '0' + s.month : '' + s.month;
        const dd = s.day   < 10 ? '0' + s.day   : '' + s.day;
        return s.year + '-' + mm + '-' + dd;
    }
    get depDateStr(): string { return this.formatStruct(this.routingForm.get('ticketDep').get('date').value); }
    get reDateStr(): string  { return this.formatStruct(this.routingForm.get('ticketRe').get('date').value); }

    /* Build a plain summary object and push it to the parent component. */
    private emitSummary() {
        if (!this.routingForm) { return; }
        const depRoute = this.routingForm.get('ticketDep').get('routeDep').value;
        const reRoute  = this.routingForm.get('ticketRe').get('routeRe').value;
        this.summaryChanged.emit({
            isRoundTrip: this.isRoundTrip,
            adult_num: this.adult_num,
            child_num: this.child_num,
            infant_num: this.infant_num,
            hasDep: !!depRoute,
            depPickStopId: depRoute ? depRoute.pick_stop_id : null,
            depDropStopId: depRoute ? depRoute.drop_stop_id : null,
            depTime: depRoute ? depRoute.pick_time : null,
            depDateStr: this.depDateStr,
            hasRe: !!(this.isRoundTrip && reRoute),
            rePickStopId: reRoute ? reRoute.pick_stop_id : null,
            reDropStopId: reRoute ? reRoute.drop_stop_id : null,
            reTime: reRoute ? reRoute.pick_time : null,
            reDateStr: this.reDateStr,
            total: this.bookingTotal
        });
    }


    /* Submit */

    onSubmit() {

        const value_raw = this.routingForm.value;
        let value = JSON.parse(JSON.stringify(value_raw));
        value.infantNum = parseInt(value.infantNum);

        // passenger num
        this.bookingService.setAdultNum(value.adultNum);
        this.bookingService.setChildNum(value.childNum);
        this.bookingService.setInfantNum(value.infantNum);

        // passenger
        this.bookingService.setPassengerAdultsValue(value.passengersAdult);
        this.bookingService.setPassengerChildrenValue(value.passengersChild);
        this.bookingService.setPassengerInfantsValue(value.passengersInfant);

        if (this.isValidTicket) {
            this.bookingService.setPnr(value.pnr);
        }

        // set is round trip
        this.bookingService.setIsRoundTrip(this.isRoundTrip);

        this.setInvoice();

        this.bookingService.submitFirst.next(true);
    }
    setInvoice() {
        this.originalAdultPriceDep = this.routingForm.get('ticketDep').get('routeDep').value.adult_price;
        this.originalChildPriceDep = this.routingForm.get('ticketDep').get('routeDep').value.child_price;
        this.originalInfantPriceDep = this.routingForm.get('ticketDep').get('routeDep').value.infant_price;
        this.originalAdultPriceRe = this.isRoundTrip ? this.routingForm.get('ticketRe').get('routeRe').value.adult_price : 0;
        this.originalChildPriceRe = this.isRoundTrip ? this.routingForm.get('ticketRe').get('routeRe').value.child_price : 0;
        this.originalInfantPriceRe = this.isRoundTrip ? this.routingForm.get('ticketRe').get('routeRe').value.infant_price : 0;

        this.bookingService.setPrice(
            this.originalAdultPriceDep,
            this.originalChildPriceDep,
            this.originalInfantPriceDep,
            this.originalAdultPriceRe,
            this.originalChildPriceRe,
            this.originalInfantPriceRe
        );
    }


    ngOnDestroy() {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
